var _defs, _circle, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBedding(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    role: "img",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bg",
    x1: 8,
    x2: 56,
    y1: 8,
    y2: 56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEF9C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEF08A"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 29,
    fill: "url(#bg)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#22C55E",
    d: "M13 38c5-6 14-9 19-5 6-5 15-1 19 5v14H13V38Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#F59E0B",
    d: "M14 39c8-5 28-5 36 0v11H14V39Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#92400E",
    strokeLinecap: "round",
    strokeWidth: 2.5,
    d: "M17 43c7-5 12-5 18 0M29 48c7-5 12-5 18 0M19 50c5-3 9-3 14 0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#84CC16",
    d: "M20 20c6-4 14-4 20 1-1 6-5 11-12 12-5-2-8-6-8-13Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#65A30D",
    d: "M28 17c8 1 14 6 16 13-6 4-14 4-20-1 0-5 1-9 4-12Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBedding);
export default __webpack_public_path__ + "static/media/bedding.e9796c71f9f1c6e486dededec2fdfdeb.svg";
export { ForwardRef as ReactComponent };